import React, { useState, useEffect } from 'react';
import StackedBarChart from './StackedBarChart';
import projectAssessmentProgressByBusinessUnitService from './project_assessment_progress_by_business_unit.service';
export default function ProjectAssessmentProgressByBusinessUnit(_ref) {
  let {
    filteredBusinessUnits,
    companyId,
    selectedSubsidiaryCompanyIds,
    selectedYears
  } = _ref;
  const [chartData, setChartData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const buIds = filteredBusinessUnits.map(bu => bu.business_unit_id).join(',');
      const scIds = selectedSubsidiaryCompanyIds.join(',');
      const data = await projectAssessmentProgressByBusinessUnitService.all(companyId, buIds, scIds, selectedYears);
      setChartData(data);
    };
    fetchData();
  }, [companyId, filteredBusinessUnits, selectedSubsidiaryCompanyIds]);
  const categories = chartData.map(d => d.business_unit_name);
  const series = [{
    name: 'Completed',
    data: chartData.map(d => d.completed_count)
  }, {
    name: 'In Progress',
    data: chartData.map(d => d.in_progress_count)
  }, {
    name: 'Not Started',
    data: chartData.map(d => d.not_started_count)
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card dashboard-card-group-chart"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-center dashboard-regular-card-title"
  }, "Project Assessment Progress"), /*#__PURE__*/React.createElement(StackedBarChart, {
    series: series,
    categories: categories,
    colors: ['#00afef', '#0078b9', '#00b08b']
  }));
}